import type { ReactElement } from "react";

interface Step {
  num: string;
  title: string;
  body: string;
}

const STEPS: Step[] = [
  {
    num: "01",
    title: "Say what you need.",
    body: "Text or email Chill, the way you would message a person. No special syntax.",
  },
  {
    num: "02",
    title: "See it on your site.",
    body: "Chill updates the right part and puts the new version where visitors can see it.",
  },
  {
    num: "03",
    title: "Keep it current.",
    body: "Hours, menus, photos, dates — another message, and it stays handled.",
  },
];

export function HowItWorks(): ReactElement {
  return (
    <section
      id="how-it-works"
      className="border-y border-[#d5e9f7] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-7 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <div>
            <div className="marketing-kicker text-[#45635e]">How it works</div>
            <h2 className="marketing-display mt-5 max-w-3xl text-5xl leading-[1.02] text-[#12211d] sm:text-6xl lg:text-7xl">
              One message is the{" "}
              <span className="block text-[#67817b]">whole workflow.</span>
            </h2>
          </div>
          <p className="max-w-xl text-lg leading-8 text-[#5e6d69] lg:justify-self-end">
            Traditional builders hand you an editor. Chill turns what you say
            into the change, then stays out of the way.
          </p>
        </div>

        <ol className="mt-16 grid border-t border-[#cadbd6] sm:grid-cols-3 sm:divide-x sm:divide-[#cadbd6]">
          {STEPS.map((s) => (
            <li
              key={s.num}
              className="border-b border-[#cadbd6] py-8 sm:border-b-0 sm:px-7 sm:py-9 first:sm:pl-0 last:sm:pr-0"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded-full border border-[#b5cdc7] bg-white font-mono text-[10px] text-[#48645e]">
                  {s.num}
                </span>
                <span className="h-px flex-1 bg-[#cadbd6] sm:hidden" />
              </div>
              <h3 className="marketing-display mt-8 text-3xl text-[#172722]">
                {s.title}
              </h3>
              <p className="mt-4 max-w-sm text-sm leading-6 text-[#65736f]">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
